'use strict';
import React from 'react';
import UserMenuComponentTemplate from './user-menu';
import ExtraMenuComponent from './extra-menu';
import HeaderMenuNavComponentTemplate from './header-navigation';

class HeaderMenuComponentTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    renderName() {
        const displayName = this.props.user.FirstName + ' ' + this.props.user.LastName;

        if (this.props.user && this.props.user.Guest === false) {
            return (
                <React.Fragment>
                    <p>Hello, {displayName}</p>
                    <img className='icon-arrow-down' src='/assets/images/icon-arrow-down.svg' alt='' />
                </React.Fragment>
            );
        }
        return (
            <p>
                <a href={this.getLoginUrl()}>REGISTER/SIGN IN</a>
            </p>
        );
    }

    shouldShowNav() {
        const hideNav = ['/dashboard', '/merchants'];
        return hideNav.some(initialPath => window.location.pathname.startsWith(initialPath));
    }

    getLoginUrl() {
        let loc = (location.pathname + location.search).substr(1);
        return `/accounts/non-private/sign-in?returnUrl=${loc}`;
    }

    handleMobileToggleClick(e) {
        $('.header.mod li.h-extramenus').slideToggle();
        $('.mobile_top_toggler > span .fa-angle-down').toggleClass('rotate');
        $('.mobile_top_toggler > span').toggleClass('_menu');

        if ($('.mobile_top_toggler > span').hasClass('_menu')) {
            var $overlay = $('<div class="menu-overlay"/>').on('click', function() {
                $('.mobile_top_toggler > span').trigger('click');
            });
            $('body').append($overlay);
        } else {
            $('.menu-overlay').remove();
        }
        window.analytics.identify(this.props.user.ID);
        window.analytics.track('dropdown menu clicked');
    }

    renderMobileMenu() {
        return (
            <div className='tog-box' id='toggle-mobile-menu'>
                <span />
                <span />
                <span />
            </div>
        );
    }

    renderHomepageUrl() {
        if (this.props.homepageUrl) {
            if (this.props.homepageUrl.startsWith('http')) {
                return this.props.homepageUrl;
            }

            return process.env.PROTOCOL + '://' + this.props.homepageUrl;
        }

        return '/';
    }

    render() {
        var pageBody = document.querySelector('body');

        return (
            <>
                <div className='header-menu-container d-flex '>
                    <div className='logo'>
                        <a href={this.renderHomepageUrl()}>
                            <img src='/assets/images/BCAA_Marketplace_Task_Horiz_RGB_White.png' />
                        </a>
                    </div>
                    <div className='header-nav hide-mobile'>
                        <ul className='d-flex'>
                            <HeaderMenuNavComponentTemplate user={this.props.user} />
                        </ul>
                    </div>
                    <div className='header-user-menu'>
                        <ul className='header-menus'>
                            <ExtraMenuComponent {...this.props} />
                            <UserMenuComponentTemplate {...this.props} />
                            <li className='mobile_top_toggler'>
                                <span onClick={e => this.handleMobileToggleClick(e)}>
                                    {/* {this.renderMobileMenu()} */}
                                    {pageBody.classList.contains('page-sidebar')
                                        ? this.renderName()
                                        : this.renderMobileMenu()}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}

export default HeaderMenuComponentTemplate;
